import { NavLink } from "react-router-dom";

const link = ({ to, label }) => (
	<NavLink className={(navData) => (navData?.isActive ? "active" : "")} to={to}>
		{label}
	</NavLink>
);

export default link;
